const moment = require('moment')

const state = function () {
    return {
        classList: [],
        loadingData: false,
        loadingCertificates: false,
        issuing: false,
        classesModalState: false,
        affiliates: [],
        includeExpiredClasses: false,
        includeInactiveAffiliates: false,
        searchAffiliates: [],
        instructors: [],
        filteredAffiliates: [],
        certificates: [],
        courses: [],
        selectedClasses: [],
        sampleDate: null,
        selectedTab: 'details',
        addEditClassOpenState: false,
        meetingLinkModal: false,
        canEdit: true,
        canRereportInd: true,
        currentSessionIndex: 0,
        currentStudentIndex: 0,
        affiliateFilter: '',
        processingClass: false,
        rereporting: false,
        initialSessionForComparison: null,
        sessionInformation: initialClassState(),
        initialSessionState: initialSessionState(),
        initialStudentRow: initialStudentRow(),
        pendingStudentRow: initialStudentRow(),
        initialState: initialClassState(),
        scheduleUploadOpen: false,
        processingSchedule: false,
        scheduleProcessed: false,
        selectedScheduleProcessRows: [],
        processedRows: [],
        classId: null,
        searchFields: {
            CLASS_ID: null,
            AFFILIATE_ID: null,
            '~INSTRUCTOR_ID': null,
            COURSE_ID: null,
            LK_CLASS_STATUS_ID: null,
            LK_CLASS_APPROVAL_STATUS_ID : null,
            '~ADDRESS_1' : null,
            'CLASS_START_DATE' : null,
            'CLASS_END_DATE' : null,
            'INCLUDE_INACTIVE_AFF': false,
            PAYMENT_STATUS: null,
        },
        canRereport: true,
    }
}

function initialSessionState () {
    return {
        label: 'Session 1',
        value: 'Session 1',
        start: '',
        startDate:'',
        startHour:'12',
        startMin:'00',
        startPeriod:'PM',
        end: '',
        endDate:'',
        endHour:'12',
        endMin:'00',
        endPeriod:'PM',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        instructors: [],
        students: [],
        maxStudents: null,
        registrationOpen: true,
        syncAddress: true,
        syncInstructors: true,
        syncStudents: true,
        syncMaxStudents: true,
        invalidStart: false,
        invalidEnd: false,
        studentsToDelete: [],
    }
}

function initialClassState () {
    return {
        rereportStudents: {},
        classId: null,
        loading: false,
        selected: 'Session 1',
        notes: '',
        mode: 'add',
        code: null,
        approvals: [],
        selectedAffiliate: null,
        selectedCourse: null,
        selectedClassType: 1, // Classroom
        meetingLink: '',
        availableInstructors: [],
        LK_CLASS_APPROVAL_STATUS_ID: 6,
        affiliates: [],
        certificates: [],
        orders: [],
        courses: [],
        sessions: [
            initialSessionState()
        ]
    }
}

function initialStudentRow () {
    return {
        selected: false,
        dl: "",
        dlState: null,
        dlStateName: '',
        lastName: "",
        firstName: '',
        middleName: '',
        address1: '',
        city: '',
        stateId: null,
        stateName: '',
        sortOrder: 0,
        zip: '',
        gender: '',
        dob: null,
        phone: '',
        email: '',
        completedDate: '',
        invalid: []
    }    
}

export default {
    ...state()
}

export const initialState = state()
